import { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardFooter,
  Col,
  Form,
  Label,
  Row,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";
import "./styles.css";
import { Link } from "react-router-dom";
import { use } from "i18next";

type Props = {
  id?: number;
  immigration_id?: string;
  application_id?: number;
  data: any;
  activeApplicationId: number | null;
  setActiveApplicationId: (id: number) => void;
  activeSection: string;
  setActiveSection: (section: string) => void;
};

const ProfileInfo = ({
  id,
  immigration_id,
  application_id,
  data,
  activeApplicationId,
  setActiveApplicationId,
  activeSection,
  setActiveSection,
}: Props) => {
  return (
    <Col lg="3" className="mb-4 mb-lg-0">
      <Card className="profile-card">
        <CardBody className="profile-body">
          <div className="profile-header text-center mb-4">
            <div className="profile-avatar">
              <h5 className="mb-1 text-white">
                {data?.employee_value
                  .split(" ")
                  .filter((part: string) => part)
                  .map((part: string) => part[0])
                  .join("")
                  .slice(0, 2)
                  .toUpperCase()}
              </h5>
            </div>
            <h4 className="mb-1 mt-3">{data?.employee_value || ""}</h4>
            <p className="text-muted small">
              <div className="btn btn-sm">
                <span className="align-middle material-symbols-outlined fw-light fs-4">
                  app_registration
                </span>
              </div>
              {data && data?.id && data?.immigration_id ? (
                <Link to={`/immigration/update-profile/${data?.id}/${data?.immigration_id}`}>
                  ID #{data?.employee_code || ""}
                </Link>
              ) : (
                "ID #"
              )}
            </p>
          </div>

          <div className="profile-info-group mb-4">
            <div className="info-item mb-3">
              <label className="label-text text-muted">Nationality</label>
              <p className="value-text">{data?.nationality_value || ""}</p>
            </div>
            <div className="info-item mb-3">
              <label className="label-text text-muted">Host country</label>
              <p className="value-text">{data?.host_country_value || ""}</p>
            </div>
            <div className="info-item mb-3">
              <label className="label-text text-muted">Assignment type</label>
              <p className="value-text">{data?.assignment_type_value || "N/A"}</p>
            </div>
            <div className="info-item">
              <label className="label-text text-muted">Status</label>
              <p className="value-text">
                <span className="badge bg-success">{data?.immigration_status_value || "N/A"}</span>
              </p>
            </div>
          </div>

          <div className="nav-section">
            <h6 className="text-muted mb-3">NAV</h6>
            {data?.applications && data?.applications?.length > 0 ? (
              data?.applications.map((application: any) => (
                <Nav vertical className="nav-sidebar" key={application.id}>
                  <NavItem>
                    <NavLink
                      className={`nav-link-item ${
                        activeApplicationId === application.id ? "active" : ""
                      }`}
                      onClick={() => setActiveApplicationId(application.id)}
                    >
                      {`Application ID #${application.application_id || "N/A"}`}
                      <br />
                      {`VISA TYPE: ${application?.application_visa_type?.visa_type_value || "N/A"}`}
                    </NavLink>
                  </NavItem>
                </Nav>
              ))
            ) : (
              <Nav vertical className="nav-sidebar">
                <NavItem>
                  <NavLink
                    className={`nav-link-item ${activeSection === "Application" ? "active" : ""}`}
                    onClick={() => setActiveSection("Application")}
                  >
                    Application
                  </NavLink>
                </NavItem>

                {application_id && (
                  <NavItem>
                    <NavLink
                      className={`nav-link-item ${activeSection === "Documents" ? "active" : ""}`}
                      onClick={() => setActiveSection("Documents")}
                    >
                      Documents
                    </NavLink>
                  </NavItem>
                )}
              </Nav>
            )}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default ProfileInfo;
